import blankAvatar from "/images/blank-avatar.png"
const UsersModule = {
  state: {
    idToken: null,
    authenticated: false,
    name: '',
    avatarSrc: null,
    loginError: null
  },
  getters: {
    loggedIn: state => state.authenticated,
    loginError: state => state.loginError,
    userId: state => state.idToken,
    userName: state => state.name,
    userAvatar: state => state.avatarSrc || blankAvatar
  },
  mutations: {
    become(state, user) {
      state.authenticated = true
      state.idToken       = user.email
      state.name          = user.name
      state.avatarSrc     = user.imageUrl
    },
    setLoginError(state, errorType) {
      state.loginError = errorType
    },
    logout(state) {
      state.authenticated = false
      state.idToken = null
      state.name = ''
      state.avatarSrc = null
      state.loginError = null
    }
  },
  actions: {
    become({ commit }, user) {
      commit("resetState")
      commit("become", user)
    },
    login({ dispatch, commit }) {
      commit("setLoginError", null)
      return dispatch("googleLogin")
        .then((userProfile) => {
          if (userProfile) {
            commit("become", userProfile)
          }
        })
        .catch((error) => {
          commit("setLoginError", error.message)
          return null
        })
    },
    logout({ commit, dispatch }) {
      return dispatch("googleLogout").then(() => {
        commit("logout")
      })
    },
    revokeAccessAndLogout({ dispatch }) {
      return dispatch("googleRevokeAccess").then(() => {
        return dispatch("googleLogout")
      })
    }
  }
}
export default UsersModule